export enum SaleStatusType {
  NOT_SOLD = 82,
  SOLD = 80,
}
